import { Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { AppFooter } from './components/AppFooter';
import { AppHeader } from './components/AppHeader';
import { ScrollOnNavigate } from './components/ScrollOnNavigate';
import { AdminPage } from './routes/AdminPage';
import { BigFiveHelpPage } from './routes/BigFiveHelpPage';
import { ContactPage } from './routes/ContactPage';
import { DiagnosisPage } from './routes/DiagnosisPage';
import { HelpPage } from './routes/HelpPage';
import { JungHelpPage } from './routes/JungHelpPage';
import { HomePage } from './routes/HomePage';
import { MyPage } from './routes/MyPage';
import { PrivacyPage } from './routes/PrivacyPage';
import { ResultPage } from './routes/ResultPage';
import { TermsPage } from './routes/TermsPage';
import { ThemeLandingPage } from './routes/ThemeLandingPage';
import { SiteProvider } from './site/SiteProvider';

/**
 * 診断側のルート。`/` は GenDan のトップ（人気の診断・自分で作る）、
 * `/t/:themeId` は診断の入口（SNS で共有される URL。生成した診断も、運営が取り込んだ診断も同じ）。
 * `/help/jung`（ユングの類型の読み方）と `/help/bigfive`（ビッグファイブ版の説明）も読み物。
 * 診断と結果には認証を挟まない。結果ページは URL を知る者が見られる公開ページ。
 * ログインが要るのは 3 つだけ（doc/AUTH.md）: 作った診断に絵を付ける（1 日 3 回）、自分の診断を管理する（`/me`）、
 * 管理メニュー（`/admin`、管理者だけ）。
 * `/terms` `/privacy` は読み物（doc/AUTH.md §13）。同意を確かめるのはアカウントを作るときだけ。
 * `/contact` は問い合わせのフォーム（要ログイン。doc/AUTH.md §14）。
 * ページを移ったときの表示位置は `ScrollOnNavigate` が受け持つ（SPA は放っておくと前の位置のまま描く）。
 */
export function App() {
  return (
    <SiteProvider>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </SiteProvider>
  );
}

function Shell() {
  return (
    <>
      <ScrollOnNavigate />
      <div className="shell">
        <AppHeader />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/t/:themeId" element={<ThemeLandingPage />} />
          <Route path="/shindan" element={<DiagnosisPage />} />
          <Route path="/r/:resultId" element={<ResultPage />} />
          <Route path="/me" element={<MyPage />} />
          <Route path="/help" element={<HelpPage />} />
          <Route path="/help/jung" element={<JungHelpPage />} />
          <Route path="/help/bigfive" element={<BigFiveHelpPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<p className="page__notice">お探しのページは見つかりませんでした。</p>} />
        </Routes>
        <AppFooter />
      </div>
    </>
  );
}
